import React, { Component } from 'react';
import{
    Container,
    Table
} from 'reactstrap';

/**
 * Used for the Listino Prezzi section. 
 */
export class Listino3 extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
        
        };
    
    }

    /**
     * Renders the page
     */
    render() {       
        const livelli4Table = (
            <Table responsive>
                <thead>
                    <tr>
                        <th>Codice</th>
                        <th>Descrizione</th>
                        <th>U.M.</th>
                        <th>Peso Medio</th>
                        <th>Prezzo</th>
                        <th>Cartonaggio</th>
                       
                       
                    </tr>
                </thead>
                <tbody>
                    {this.props.livelli4.map(element => {
                                //console.log(element)
                                return(
                                    <tr key={element.articoloId}>
                                        {this.props.nuovoOrdine ? <th><a onClick={() => this.props.handleCodiceArticoloClick(element)} style={{color: "blue", cursor: "pointer"}}>{element.articoloId}</a></th> : <th>{element.articoloId}</th>}
                                        <td>{element.descrizione}</td>
                                        <td>{element.um}</td>
                                        <td>{element.pesoMedio}</td>
                                        <td>€ {parseFloat(element.listino).toFixed(2)}</td>
                                        <td>{element.cartonaggio}</td>
                                        
                                    </tr>
                                    
                            )
                        }) 
                    }
                </tbody>
            </Table>
        );


        return(
            <Container fluid> 
                {this.props.showLivelli4 ? livelli4Table : null}
            </Container>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Listino/Listino3.js